import { createAction, createSlice, } from "@reduxjs/toolkit";
const initialState = {
    loading: true,
    error: "",
    gradeMappingList: [],
    courseMappingList: [],
    courseMappingListV2:[],
    current: {},
    index: null,
    grades: [],
    levelsList:[]
};

export const irGradingSlice = createSlice({
    name: "irGrade",
    initialState,
    reducers: {
        setIsLoading(state, action) {
            state.loading = action.payload;
        },
        setGradeMapping(state, action) {
            let data = action.payload;
            state.gradeMappingList = data;
            state.loading = false;
        },
        deleteGradeMapping(state, action) {
            let { id } = action.payload;
            state.gradeMappingList = state.gradeMappingList.filter(e => e.gradeId != id);
        },
        setCurrentGradeMapping(state, action) {
            let { id } = action.payload;
            state.current = state.gradeMappingList.find(e => e.irGradingId == id);
            const index = state.gradeMappingList.findIndex(obj => obj.irGradingId === id);
            state.index = index;
        },
        createSetGradeMapping(state, action) {
            // let data = state.gradeMappingList.push(action.payload.grade)
            state.gradeMappingList = [...state.gradeMappingList, action.payload.grade];
            state.loading = false;
        },
        updateSetGradeMapping(state, action) {
            state.gradeMappingList[state.index] = action.payload.grade;
            state.loading = false;
        },
        setCourseMapping(state, action) {
            state.courseMappingList = action.payload;
            state.loading = false;
        },
        setCourseMappingV2(state, action) {
            state.courseMappingListV2 = action.payload;
            state.loading = false;
        },
        setGrades(state, action) {
            state.grades = action.payload;
            state.loading = false;
        },
        setLevels(state,action){
            state.levelsList = action.payload.data;
            state.loading = false;
        },
        addLevelSuccess(state, action) {
            state.levelsList = [...state.levelsList,action.payload];
            state.loading = false;
        },
        removeLevel(state,action){
            state.levelsList = state.levelsList.filter(level => level.id !== action.payload);
        }
    },
});


export const irGradeAction = {
    loadGradeMapping: createAction(`${irGradingSlice.name}/loadGradeMapping`, (payload) => ({ payload })),
    loadCourseMapping: createAction(`${irGradingSlice.name}/loadCourseMapping`, (payload) => ({ payload })),
    loadCourseMappingV2: createAction(`${irGradingSlice.name}/loadCourseMappingV2`, (payload) => ({ payload })),
    loadAllGrades: createAction(`${irGradingSlice.name}/loadAllGrades`, (payload) => ({ payload })),
    loadLevels: createAction(`${irGradingSlice.name}/loadLevels`, (payload) => ({ payload })),
    addLevel: createAction(`${irGradingSlice.name}/addLevel`, (payload) => ({ payload })),
    deleteLevel: createAction(`${irGradingSlice.name}/deleteLevel`, (payload) => ({ payload })),
    // loadCurrentGradeMapping: createAction(`${irGradingSlice.name}/changeCurrentGradeMapping`, (payload) => ({ payload })),
    // saveCurrentGradeMapping: createAction(`${irGradingSlice.name}/saveGradeMapping`, (payload) => ({ payload })),
    // createGradeMapping: createAction(`${irGradingSlice.name}/createGradeMapping`, (payload) => ({ payload })),
    removeGradeMapping: createAction(`${irGradingSlice.name}/removeGradeMapping`, (payload) => ({ payload })),
    saveCurrentGradeMapping: irGradingSlice.actions.updateSetGradeMapping,
    loadCurrentGradeMapping: irGradingSlice.actions.setCurrentGradeMapping,
    createGradeMapping: irGradingSlice.actions.createSetGradeMapping,
    deleteGradeMapping: irGradingSlice.actions.deleteGradeMapping,
    setGradeMapping: irGradingSlice.actions.setGradeMapping,
    setCurrentGradeMapping: irGradingSlice.actions.setCurrentGradeMapping,
    setCourseMapping: irGradingSlice.actions.setCourseMapping,
    setCourseMappingV2: irGradingSlice.actions.setCourseMappingV2,
    setGrades: irGradingSlice.actions.setGrades,
    setLevels: irGradingSlice.actions.setLevels,
    addLevelSuccess: irGradingSlice.actions.addLevelSuccess,
    removeLevel: irGradingSlice.actions.removeLevel
};

export const getGradeMapping = (state) => state.irGrade.gradeMappingList;
export const getCourseMapping = (state) => state.irGrade.courseMappingList;
export const getCourseMappingV2 = (state) => state.irGrade.courseMappingListV2;
export const getCurrentGradeMapping = (state) => state.irGrade.current;
export const isLoading = (state) => state.irGrade.loading;
export const getPagination = (state) => state.irGrade.pagination;
export const currentIndex = (state) => state.irGrade.index;
export const getGrades = (state) => state.irGrade.grades;
export const getLevels = (state) => state.irGrade.levelsList; 

export default irGradingSlice.reducer;